import { toObservable } from '@angular/core/rxjs-interop';
import { computed, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private readonly _counter = signal(0);
  private readonly _isLoading = computed(() => {
    return this._counter() > 0;
  });

  private readonly _isLoading$ = toObservable(this._isLoading);

  public show(): void {
    this._counter.update(value => value + 1);
  }

  public hide(): void {
    this._counter.update(value => Math.max(0, value - 1));
  }

  public isLoading(): Observable<boolean> {
    return this._isLoading$;
  }
}
